// src/components/Services.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import '../App.css';

const API_URL = 'https://un-borders.com';

// 🔹 إعدادات حركة الدخول المتدرج (Stagger Effect)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, type: 'spring', stiffness: 90 }
  }
};

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/services/`)
      .then(response => {
        setServices(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the services!", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', color: '#daa520', fontSize: '1.5rem', fontWeight: 'bold' }}>
        جاري تحميل خدماتنا الهندسية...
      </div>
    );
  }

  return (
    <div className="services-page" style={{ paddingBottom: '80px', overflow: 'hidden' }}>
      
      {/* 🟩 العنوان الرئيسي للصفحة */}
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{ textAlign: 'center', marginBottom: '60px' }}
      >
        <h1 style={{ color: '#daa520', fontSize: '3rem', textShadow: '0px 4px 15px rgba(218, 165, 32, 0.3)', marginBottom: '15px' }}>
          خدماتنا
        </h1>
        <p style={{ color: '#c0c0c0', fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto', lineHeight: '1.6' }}>
          نقدم حلولاً هندسية ومعمارية متكاملة تتجاوز الحدود المألوفة لنبني رؤيتك على أرض الواقع.
        </p>
      </motion.div>

      {/* 🟩 شبكة كروت الخدمات */}
      <motion.div 
        className="services-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {services.map((service) => {
          const IconComponent = FaIcons[service.icon_name];
          return (
            <motion.div
              key={service.id}
              className="service-card"
              variants={cardVariants}
              whileHover={{ 
                scale: 1.03, 
                y: -12, 
                boxShadow: '0 20px 40px rgba(218, 165, 32, 0.15)',
                borderColor: 'rgba(218, 165, 32, 0.4)'
              }}
              style={{
                position: 'relative',
                background: 'linear-gradient(145deg, #2e354a 0%, #1a1a2e 100%)',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                borderRadius: '16px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: '30px 20px'
              }}
            >
              {/* تأثير التوهج الخلفي (Glow) عند مرور الماوس */}
              <motion.div 
                style={{
                  position: 'absolute',
                  top: '-50%',
                  left: '-50%',
                  width: '200%',
                  height: '200%',
                  background: 'radial-gradient(circle, rgba(218,165,32,0.08) 0%, transparent 60%)',
                  opacity: 0,
                  pointerEvents: 'none',
                  transition: 'opacity 0.4s ease'
                }}
                whileHover={{ opacity: 1 }}
              />

              <div style={{ position: 'relative', zIndex: 2 }}>
                {/* 🔹 الأيقونة بحركة دوران ناعمة */}
                {IconComponent && (
                  <motion.div
                    whileHover={{ rotate: 15, scale: 1.15 }}
                    transition={{ type: 'spring', stiffness: 200 }}
                    style={{ display: 'inline-block', marginBottom: '20px' }}
                  >
                    <IconComponent className="service-icon" style={{ fontSize: '3.5rem', color: '#daa520', filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.3))' }} />
                  </motion.div>
                )}

                <h3 style={{ fontSize: '1.6rem', margin: '0 0 15px 0', color: '#ffffff' }}>{service.title}</h3>
                <p style={{ color: '#b0b0b0', lineHeight: '1.8', fontSize: '1rem', marginBottom: '30px' }}>
                  {service.description}
                </p>
              </div>

              {/* 🔹 زرار الانتقال للمشاريع */}
              <div style={{ position: 'relative', zIndex: 2, marginTop: 'auto' }}>
                <Link
                  to={`/services/${encodeURIComponent(service.title)}`}
                  className="service-button"
                  style={{ 
                    display: 'block', 
                    width: '100%', 
                    boxSizing: 'border-box',
                    textAlign: 'center', 
                    padding: '12px 0',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    letterSpacing: '0.5px',
                    margin: '0' // لإلغاء أي Margin خارجي من الـ CSS القديم
                  }}
                >
                  استكشف المشاريع
                </Link>
              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
}

export default Services;